import { buildVenuePath } from '../utils/venueRouting';
// src/pages/ServiceSub.jsx
import React, { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { contentLog } from '../utils/Accesslog.js';
import BackButton from '../components/BackButton';
import AppContext from '../contexts/AppContext';
import { Carousel } from 'react-responsive-carousel';
import { resolveSidebarIconSrc } from '../utils/IconSource.js';


const ServiceSub = () => {
  const { id } = useParams();
  const { contentInfo, hotelInfo, venueId, theme } = useContext(AppContext);
  const [detail, setDetail] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const findNodeById = (tid, node) => {
      const queue = [node];
      while (queue.length > 0) {
        const currentNode = queue.shift();
        if (currentNode.id === tid) return currentNode;
        if (currentNode.attributes) {
          queue.push(...currentNode.attributes);
        }
      }
      return null;
    };
    if (id && contentInfo) {
      const node = findNodeById(id, contentInfo)
      setDetail(node)
    }
  }, [contentInfo, id])

  const handleServiceClick = (data) => {
    contentLog(venueId, data.id);
    if (data.isLeaf) {
      navigate(buildVenuePath(`/service/detail/${data.id}`, venueId))
    } else {
      navigate(buildVenuePath(`/service/list/${data.id}`, venueId))
    }
  }

  if (!hotelInfo) { return <div>Loading...</div>; }

  const servicesHeader = (theme?.color || theme?.secondaryColor) ? 'rgb(0,0,0)' : (theme?.servicesHeader || 'rgb(0,0,0)');
  const servicesEntries = (theme?.color || theme?.secondaryColor) ? 'rgb(0,0,0)' : (theme?.servicesEntries || 'rgb(0,0,0)');
  const servicesBackground = (theme?.color || theme?.secondaryColor) ? "rgb(255,255,255)" : theme?.servicesBackground || 'rgb(255,255,255)';
  const servicesCardsBackground = (theme?.color || theme?.secondaryColor) ? "rgb(255,255,255)" : theme?.servicesCardsBackground || 'rgb(255,255,255)';
  

  return (
    <div className='min-h-[calc(100vh-9rem)]' style={{ backgroundColor: servicesBackground }}>
      <BackButton />
      {detail && detail.bannerImage && <img
        src={detail.bannerImage}
        alt={"Banner list"}
        className="object-cover w-full h-auto"
      />}
      {detail && !detail.bannerImage && detail.carouselImage && detail.carouselImage.length > 0 &&
        (detail.carouselImage.length === 1
          ? <img src={detail.carouselImage[0]} alt='serviceImage' className='object-cover w-full h-36' />
          :
          <Carousel
            showArrows={true}
            showThumbs={false}
            infiniteLoop={true}
            autoPlay={true}
            showIndicators={false}
            showStatus={false}
            className="w-full h-full"
          >
            {detail.carouselImage.map((slide, index) => (
              <div key={index} className="w-full h-full">
                <img
                  src={slide}
                  alt={`Home ${index + 1}`}
                  className="object-cover w-full h-36"
                />
              </div>
            ))}
          </Carousel>
        )}
      <div className='flex flex-col items-center px-2 py-4'>
        <p className='text-xl font-semibold ' style={{ color: servicesHeader }}>{detail && detail.name}</p>
      </div>
      <div className='grid grid-cols-2 max-w-md mx-auto px-2'>
        {detail && detail.attributes && detail.attributes.length > 0 && detail.layoutStyle === "sidebar" &&
          detail.attributes.map((data, index) => {
            const iconSrc = resolveSidebarIconSrc(data);
            return (
              <div key={data.id} className="flex flex-col items-center px-2 py-2 m-2 bg-white rounded-lg min-h-28 shadow-md"
                onClick={() => handleServiceClick(data)}>

                <div className="w-full flex items-center justify-center m-2" style={{ backgroundColor: servicesCardsBackground }}>
                  {iconSrc && (
                    <img
                      src={iconSrc}
                      alt={"IconImage " + index}
                      className="object-cover rounded-lg w-12 h-12"
                      onError={(event) => {
                        event.currentTarget.style.display = 'none';
                      }}
                    />
                  )}
                </div>
                <p className="font-semibold text-center mt-0 text-sm" style={{ color: servicesEntries }}>{data.name}</p>
              </div>
            );
          })}

        {detail && detail.attributes && detail.attributes.length > 0 && detail.layoutStyle === "overlay" &&
          detail.attributes.map((data, index) => (
            <div key={data.id} className="flex flex-col items-center px-2 pt-2"
              onClick={() => handleServiceClick(data)}>
              <div className="w-full aspect-w-1 aspect-h-1">
                <img
                  src={data.bannerImage}
                  alt={"BannerImage " + index}
                  className="object-cover rounded-lg w-full h-full"
                />
              </div>

              <p className="mt-1 font-semibold text-sm" style={{ color: servicesEntries }}>{data.name}</p>
            </div>
          ))}
      </div>

    </div>
  );
};

export default ServiceSub;
